import LoginPage from "./page/LoginPage";
import CruiseListPage from "./page/CruiseListPage";
import CruiseDetailPage from "./page/CruiseDetailPage";
import SeatourListPage from "./page/SeatourListPage";
import SeatourDetailPage from "./page/SeatourDetailPage";
import PortListPage from "./page/PortListPage";
import PortDetailPage from "./page/PortDetailPage";
import SailListPage from "./page/SailListPage";
import SailDetailPage from "./page/SailDetailPage";
import PriceListPage from "./page/PriceListPage";
import PriceDetailPage from "./page/PriceDetailPage";
import AgencyListPage from "./page/AgencyListPage";
import AgencyDetailPage from "./page/AgencyDetailPage";
import MarketListPage from "./page/MarketListPage";
import PaymentListPage from "./page/PaymentListPage";
import CouponListPage from "./page/CouponListPage";
import BookingListPage from "./page/BookingListPage";
import BookingDetailPage from "./page/BookingDetailPage";
import SettingsPage from "./page/SettingsPage";
import ForeCastPage from "./page/ForeCastPage";
import DashboardAppPage from "./page/DashboardAppPage";
import AgencyPaymentsOutlinePage from "./page/AgencyPaymentsOutlinePage";
import ProformaListPage from "./page/ProformaListPage";
import CurrentStatusReport from "./page/CurrentStatusReport";
import CountryListPage from "./page/CountryListPage";
import CityListPage from "./page/CityListPage";
import DistrictListPage from "./page/DistrictListPage";

import AgencyReservationReport from "./page/AgencyReservationReport";
import AgencyBookingConfirmationListPage from "./page/AgencyBookingConfirmationListPage";
import RoleRightPage from "./page/RoleRightPage";
import AuthRoleListPage from "./page/AuthRoleListPage";
import AccessLogsPage from "./page/AccessLogsPage";
import AdditionalServicePriceList from "./component/price/AdditionalServicePriceList";
import AdditionalServicePriceListPage from "./page/AdditionalServicePriceListPage";
import AdditionalServicePricePage from "./page/AdditionalServicePricePage";
import BookingDetailArchivedPage from "./page/BookingDetailArchivedPage";
import BookingListArchivedPage from "./page/BookingListArchivedPage";
import ForeCastReport from "./page/ForeCastReport";
import EndpointStatsPage from "./page/EndpointStatsPage";
import EmailEditorPage from "./page/EmailEditorPage";
import BookingAgencyCommissionReportPage from "./page/BookingAgencyCommissionReportPage";
import GroupReservationPage from "./page/GroupReservationPage";
import ProformaDetailPage from "./page/ProformaDetailPage.vue";
import ProformaInvoiceListPage from "./page/ProformaInvoiceListPage.vue";
import AgencyPaymentDetailPage from "./page/AgencyPaymentDetailPage.vue";


export const router = [
    { path: "/", name: "cruiseList", component: CruiseListPage },
    { path: "/cruises", name: "cruiseList", component: CruiseListPage },
    { path: "/cruises/:id", name: "cruise", component: CruiseDetailPage },
    { path: "/seatours", name: "seaTours", component: SeatourListPage },
    { path: "/seatours/:id", name: "seaTour", component: SeatourDetailPage },
    { path: "/ports", name: "ports", component: PortListPage},
    { path: "/ports/:id", name: "port", component: PortDetailPage },
    { path: "/sails", name: "sails", component: SailListPage },
    { path: "/sails/:id", name: "sail", component: SailDetailPage },
    { path: "/pricings", name: "pricings", component: PriceListPage },
    { path: "/pricings/:id", name: "pricing", component: PriceDetailPage },
    { path: "/additional-service/pricings", name: "additionalServicePricings", component: AdditionalServicePriceListPage },
    { path: "/additional-service/pricings/:id", name: "additionalServicePricing", component: AdditionalServicePricePage },
    { path: "/agencies", name: "agencies", component: AgencyListPage },
    { path: "/agencies/:id", name: "agency", component: AgencyDetailPage },
    { path: "/agency/outline", name: "agencyOutline", component: AgencyPaymentsOutlinePage },
    { path: "/agency/proforma", name: "proforma", component: ProformaListPage },
    { path: "/agency/payment-details/:id", name: "agencyPaymentDetails", component: AgencyPaymentDetailPage },
    { path: "/markets", name: "markets", component: MarketListPage },
    { path: "/countries", name: "countries", component: CountryListPage },
    { path: "/cities", name: "cities", component: CityListPage },
    { path: "/districts", name: "districts", component: DistrictListPage },
    { path: "/payments", name: "payments", component: PaymentListPage },
    { path: "/coupons", name: "coupons", component: CouponListPage },
    { path: "/bookings", name: "bookings", component: BookingListPage },
    { path: "/bookings/archived", name: "bookings-archived", component: BookingListArchivedPage },
    { path: "/bookings/confirmation", name: "booking-confirmation", component: AgencyBookingConfirmationListPage },
    { path: "/bookings/archived/:id", name: "booking-archived", component: BookingDetailArchivedPage },
    { path: "/bookings/:id", name: "booking", component: BookingDetailPage },
    // { path: "/booking-assistance", name: "bookingAssistance", component: FormListPage },
    { path: "/settings", name: "settings", component: SettingsPage },
    { path: "/forecast", name: "forecast", component: ForeCastPage },
    { path: "/roleright", name: "roleright", component: RoleRightPage },
    { path: "/roles", name: "roles", component: AuthRoleListPage },
    { path: "/access-logs", name: "accessLogs", component: AccessLogsPage },
    { path: "/endpoint-stats", name: "endpointStats", component: EndpointStatsPage },
    { path: "/sefer-rezervasyon-raporu", name: "currentStatusReport", component: CurrentStatusReport },
    { path: "/forecast-raporu", name: "forecastReport", component: ForeCastReport },
    { path: "/booking-agency-commission-report", name: "bookingAgencyCommissionReport", component: BookingAgencyCommissionReportPage },
    { path: "/acente-rezervasyon-raporu", name: "agentReservationReport", component: AgencyReservationReport },
    { path: "/reports/:id", name: "report", component: DashboardAppPage },
    { path: "/email-editor", name: "emailEditor", component: EmailEditorPage },
    { path: "/group-reservation", name: "groupReservation", component: GroupReservationPage },
    { path: "/proforma-detail/:id", name: "proformaDetail", component: ProformaDetailPage },
    { path: "/proforma-invoices", name: "proformaInvoices", component: ProformaInvoiceListPage },
    { path: "/login", name: "LoginPage", component: LoginPage },
    { path: "/**", redirect: "/" },
    // { path: "*", redirect: "/" }
];



